import {Injectable, NgZone} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class GrowlService {

    constructor(private toastr: ToastrService,
                private ngZone: NgZone,
                private translateService: TranslateService) {
    }

    showInfoGrowl(code: string, params: any = {}) {
        this.ngZone.run(() => {
            this.toastr.success(this.translateService.instant(code, params), this.translateService.instant('LABEL.GROWL_SUCCESS_TITLE'));
        });
    }

    showErrorGrowl(code: string, params: any = {}) {
        this.ngZone.run(() => {
            this.toastr.error(this.translateService.instant(code, params), this.translateService.instant('LABEL.GROWL_ERROR_TITLE'));
        });
    }
}
